export default "__VITE_ASSET__C$I2C27E__"